import React from 'react'
import './styles.css'
import callToAction from '../../../assets/img/callToAction.png'
import useAnalyticsEventTracker from '../utils/useAnalyticsEventTracker';

export default function CallToAction({
  children,
  marginRight,
  width,
  gap = 16,
}) {
  const handleWhatsAppRedirect = () => {
    const phoneNumber = '+553193716866'
    const message = 'Olá, gostaria de agendar uma consulta.' // Mensagem pré-preenchida (opcional)
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message,
    )}`

     const GaEvent = () => useAnalyticsEventTracker();
     console.log(GaEvent);

    window.location.href = whatsappUrl
  }
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true)
    }
  }, [])

  return (
    <button
      className="call-to-action"
      onClick={handleWhatsAppRedirect}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: marginRight ? marginRight : '0',
        width: width,
        gap: !gap ? gap : '16px',
      }}
    >
      <text
        style={{
          fontSize: !isMobile ? '14px' : '11px',
          fontWeight: 'bold',
          color: 'white',
          paddingLeft: !isMobile ? '10px' : '10px',
          fontFamily: 'Poppins, sans-serif',
          fontWeight: !isMobile ? 600 : 400,
          textAlign: 'center',
          textTransform: 'uppercase',
          cursor: 'pointer',
          transition: 'background-color 0.3s',
          color: '#ffffff',
        }}
      >
        {children}
      </text>
      <img
        style={{
          width: !isMobile ? '20px' : '30px',
          height: !isMobile ? '20px' : '30px',
          paddingRight: !isMobile ? '10px' : '10px',
        }}
        src={callToAction}
        alt="arrow-right"
      />
    </button>
  )
}
